import { useAsync } from '@tiger/hooks';
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import PlaidLink from 'components/vendor/plaid/PlaidLink';
import security from 'stores/security';
import { Source } from 'types/funding';
import API from 'utils/API';
import http from 'utils/http';
import URL from 'utils/URL';

interface PlaidContinueProps {
    source: Source;
}

const PlaidContinue: React.FC<PlaidContinueProps> = ({ source }) => {
    const navigate = useNavigate();

    const [{ loading, error, data }, getData] = useAsync(() =>
        http
            .get<{
                public_token: string;
            }>(API.TRADE.funding.getCacheLinkToken(), {
                params: {
                    customer_id: security.currentCustomerId
                }
            })
            .then(({ data }) => data)
    );
    const [loadingPlaid, setLoadingPlaid] = useState(false);

    const handleExit = () => {
        navigate(`/profile/${source}/ach`);
    };

    const handleSuccess = () => {
        setLoadingPlaid(true);
    };

    const render = () => {
        if (!URL.current().query.oauth_state_id) {
            return <Navigate to={`/profile/${source}/ach`} />;
        }

        if (loading || loadingPlaid) {
            return <Loading />;
        }

        if (error) {
            return <ErrorBox error={error} onClick={getData} />;
        }

        return (
            <PlaidLink
                source={source}
                hideBtn
                receivedRedirectUri={window.location.href}
                onExit={handleExit}
                onSuccess={handleSuccess}
                token={data?.public_token}
            />
        );
    };

    return <div className="plaid-continue-root">{render()}</div>;
};

export default PlaidContinue;
